import axios from "axios";
import config from "config/config";
import store from "store";
import { get } from "lodash";
import { toastr } from "services/toastr";
import ERROR from "constant/error";
import { history } from "redux/store";

const baseURL = config.API_ENDPOINT;
const apiClient = axios.create({
  baseURL,
  timeout: 20000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
apiClient.interceptors.request.use(
  (request) => {
    const accessToken = store.get("token");
    if (accessToken) {
      request.headers = request.headers || {};
      request.headers.authorization = accessToken.token;
    }
    store.set("offline", false);
    return request;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response } = error;
    const propagateError = get(error, ["config", "propagateError"], false);
    // eslint-disable-next-line no-console
    console.info("#####INTERCEPTORS#####", response, error);
    if (!response) {
      store.set("offline", true);
      if (propagateError) throw error;
      return;
    }

    const { data, status } = response;
    let message = get(data, "message");
    const code = get(error, ["code"], "");
    let name = get(data, "name");
    const errorLib = ERROR[name];
    if (errorLib) {
      message = errorLib.message;
      if (errorLib.name) {
        name = errorLib.name;
      }
    }
    // const requestURL = get(response, ["request", "responseURL"], "");

    if (status === 401) {
      // A successful system import intentionally invalidates every session.
      // Keep its read-only receipt so the login redirect/reload can still show
      // whether the import completed or started the default configuration.
      const maintenanceReceipt = ["maintenanceImportJobId", "maintenanceImportStatusToken"]
        .map((key) => [key, window.localStorage.getItem(key)]);
      history.push("/login");
      store.clearAll();
      maintenanceReceipt.forEach(([key, value]) => {
        if (value) window.localStorage.setItem(key, value);
      });
      return;
    }

    if (status === 404) {
      toastr.error(`status ${status}`, error.message);
      history.push("/404");
      return;
    }

    if (code === "ERR_NETWORK") {
      const url = get(error, ["config", "url"], "");
      const method = get(error, ["config", "method"], "");
      if (url === "/api/health-check" || (url === "/api/v1/settings/factory-reset-status" && method === "get")) {
        return;
      }
      toastr.error(code, error.message);
      return;
    }

    if (status === 500) {
      toastr.error("Error", "Internal Server Error");
      if (propagateError) throw error;
      return;
    }

    if (propagateError) throw error;
    toastr.error(name, message);

    if (status >= 500) {
      throw error;
    }
  }
);

export default apiClient;
